import _get from 'lodash/get'
import { fromJS, Map, List } from 'immutable'
import _toNumber from 'lodash/toNumber'
import _toInteger from 'lodash/toInteger'
import _assign from 'lodash/assign'
import _cloneDeep from 'lodash/cloneDeep'
import _omitBy from 'lodash/omitBy'
import _isUndefined from 'lodash/isUndefined'
import _isString from 'lodash/isString'
import {
  TYPE_CONTENT_SERIES,
  TYPE_CONTENT_VIDEO,
  getBaseContentType,
} from 'services/content-type'
import {
  PLAN_SKU_ONE_WEEK_FREE_TRIAL_TO_MONTHLY,
  PLAN_SKU_MONTHLY,
  PLAN_SKU_ONE_WEEK_FREE_TRIAL_TO_ANNUAL,
  PLAN_SKU_ANNUAL,
  PLAN_SKU_LIVE,
  PLAN_SKU_INCREASED_PRICE_ONE_WEEK_FREE_TRIAL_TO_ANNUAL,
  PLAN_SKU_INCREASED_PRICE_ONE_WEEK_FREE_TRIAL_TO_MONTHLY,
  PLAN_SKU_INCREASED_PRICE_MONTHLY,
  PLAN_SKU_INCREASED_PRICE_ANNUAL,
  PLAN_SKU_INCREASED_PRICE_GAIA_PLUS,
  PLAN_SKU_PRICE_INCREASE_2026_MONTHLY,
  PLAN_SKU_PRICE_INCREASE_2026_MONTHLY_CL,
  PLAN_SKU_PRICE_INCREASE_2026_ANNUAL,
  PLAN_SKU_PRICE_INCREASE_2026_MONTHLY_TRIAL,
  PLAN_SKU_PRICE_INCREASE_2026_ANNUAL_TRIAL,
} from 'services/plans'
import { createTitleGroupId } from 'services/content'

export const FACEBOOK_PIXEL_TEST_CODE_KEY = 'FACEBOOK_PIXEL_TEST_CODE'
export const FACEBOOK_EVENT_NAME_PURCHASE = 'Purchase'
export const FACEBOOK_EVENT_NAME_USER_PURCHASED_FREE_TRIAL = 'user_purchased_free_trial'
export const FACEBOOK_EVENT_NAME_USER_PURCHASED_DIRECT = 'user_purchased_direct_to_paid'
export const FACEBOOK_EVENT_NAME_PAGE_VIEW = 'PageView'
export const FACEBOOK_EVENT_NAME_LEAD = 'Lead'
export const FACEBOOK_EVENT_NAME_INITIATE_CHECKOUT = 'InitiateCheckout'
export const FACEBOOK_EVENT_NAME_VIEW_CONTENT = 'ViewContent'
export const FACEBOOK_EVENT_ACTION_SOURCE = 'website'

export const PURCHASED_MONTHLY_WITH_TRIAL = 'Purchased Monthly With Trial'
export const PURCHASED_MONTHLY_DIRECT = 'Purchased Monthly Direct'
export const PURCHASED_ANNUAL_WITH_TRIAL = 'Purchased Annual With Trial'
export const PURCHASED_ANNUAL_DIRECT = 'Purchased Annual Direct'
export const PURCHASED_EVENTS_PLUS = 'Purchased Events Plus'
export const PURCHASED_PROMOTIONAL_PLAN = 'Purchased Promotional Plan'
export const QUALIFIED = 'Qualified'
export const SERIES_CLICK = 'Series Click'
export const TITLE_CLICK = 'Title Click'
export const PLAY_EVENT = 'Play Event'
export const EVENT_ACTION_PLAY_CLICK = 'Play Click'
export const EVENT_ACTION_TILE_CLICK = 'Click Tile'
export const NOTIFICATIONS = 'Notifications'
export const IMPRESSION_ACTION = 'Impression'
export const EMAIL_OPT_IN_SETTINGS_ON = 'on'
export const EMAIL_OPT_IN_SETTINGS_OFF = 'off'

// Server events
export const SERVER_EVENT_PURCHASE = 'Purchase'
export const SERVER_EVENT_PAGE_VIEW = 'PageView'
export const SERVER_EVENT_LEAD = 'Lead'
export const SERVER_EVENT_INITIATE_CHECKOUT = 'InitiateCheckout'
export const SERVER_EVENT_VIEW_CONTENT = 'ViewContent'
export const SERVER_EVENT_USER_PURCHASED_FREE_TRIAL = 'user_purchased_free_trial'
export const SERVER_EVENT_USER_PURCHASED_DIRECT = 'user_purchased_direct_to_paid'

// GA4 events
export const EVENT_PLAY_CLICK = 'play_click'
export const EVENT_PLAY_LIST_CREATED = 'playlist_created'
export const EVENT_PLAY_LIST_DELETED = 'playlist_deleted'
export const EVENT_PLAY_LIST_SHARED = 'playlist_shared'
export const EVENT_REMOVED_FROM_PLAY_LIST = 'removed_from_playlist'
export const EVENT_ADDED_TO_PLAY_LIST = 'added_to_playlist'
export const EVENT_ACCOUNT_PAUSED = 'account_paused'
export const EVENT_ACCOUNT_UNPAUSED = 'account_unpaused'
export const EVENT_PAUSED_OFFER_SHOWN = 'paused_offer_shown'
export const EVENT_ROW_IMPRESSION = 'row_impression'
export const EVENT_TOPIC_CLICKED = 'topic_clicked'
export const EVENT_PRIMARY_LANGUAGE_CHANGED = 'language_changed'
export const EVENT_SECONDARY_LANGUAGE_CHANGED = 'secondary_language_changed'
export const EVENT_EMAIL_CAPTURED = 'email_captured'
export const EVENT_EMAIL_PERMISSION_TOGGLED = 'email_permission_toggled'
export const EVENT_AUTOPLAY_TOGGLED = 'autoplay_toggled'
export const EVENT_COMMENT = 'comment'
export const EVENT_ITEM_REMOVED_FROM_HISTORY = 'item_removed_from_history'
export const EVENT_SERIES_FOLLOWED = 'series_followed'
export const EVENT_SERIES_UNFOLLOWED = 'series_unfollowed'
export const EVENT_NOTIFICATIONS_OPENED = 'notifications_opened'
export const EVENT_NOTIFICATIONS_MANAGE_CLICKED = 'notifications_manage_clicked'
export const EVENT_NOTIFICATIONS_VIEW_ALL_CLICKED = 'notifications_view_all_clicked'
export const EVENT_CANCEL_FLOW_REASON_SELECTED = 'cancel_flow_reason_selected'
export const EVENT_CANCEL_FLOW_FREE_MONTH_SELECTED = 'cancel_flow_free_month_selected'
export const EVENT_CANCEL_FLOW_FREE_MONTH_OFFER_SHOWN = 'cancel_flow_free_month_offer_shown'
export const EVENT_CANCEL_FLOW_CHANGE_PLAN_SELECTED = 'cancel_flow_change_plan_selected'
export const EVENT_CANCEL_FLOW_FREE_MONTH_REJECTED = 'cancel_flow_free_month_rejected'
export const EVENT_CANCEL_FLOW_CANCEL_CLICKED = 'cancel_flow_cancel_clicked'
export const EVENT_CANCEL_FLOW_THREE_MONTH_OFFER_SHOWN = 'cancel_flow_three_month_offer_shown'
export const EVENT_CANCEL_FLOW_THREE_MONTH_OFFER_SELECTED = 'cancel_flow_three_month_offer_selected'
export const EVENT_CANCEL_FLOW_THREE_MONTH_OFFER_REJECTED = 'cancel_flow_three_month_offer_rejected'
export const EVENT_CHANGE_PLAN_OFFER_VIEW = 'change_plan_offer_view'
export const EVENT_CHANGE_PLAN_OFFER_ACCEPT = 'change_plan_offer_accept'
export const EVENT_CHANGE_PLAN_OFFER_CONFIRM = 'change_plan_offer_confirm'
export const EVENT_CANCEL_FLOW_PRICE_INCREASE_OFFER_SHOWN = 'cancel_flow_price_increase_offer_shown'
export const EVENT_CANCEL_FLOW_PRICE_INCREASE_OFFER_SELECTED = 'cancel_flow_price_increase_offer_selected'
export const EVENT_CANCEL_FLOW_PRICE_INCREASE_OFFER_CONFIRMED = 'cancel_flow_price_increase_offer_confirmed'
export const EVENT_CANCEL_FLOW_PRICE_INCREASE_OFFER_REJECTED = 'cancel_flow_price_increase_offer_rejected'
export const EVENT_SPOTLIGHT_TOGGLED = 'spotlight_toggled'
export const EVENT_AI_MODULE_VISIBILITY_TOGGLED = 'ai_module_visibility_toggled'
export const EVENT_AI_VIDEO_GUIDE_TOGGLED = 'settings_ai_video_guide_toggled'
export const EVENT_NAV_CLICKED = 'nav_clicked'
export const EVENT_PROMO_UNIT_IMPRESSION = 'promo_unit_impression'
export const EVENT_PROMO_UNIT_CLICK = 'promo_unit_click'
export const EVENT_CLICK_TO_DETAILS_PAGE = 'click_to_detail_page'
export const EVENT_VIDEO_PLAYER_OPENED = 'video_player_opened'
export const EVENT_VIDEO_LOADS_AND_STARTS_PLAY = 'video_loads_and_starts_to_play'
export const EVENT_SHARE_INITIATED = 'share_initiated'
export const EVENT_SHARE_COMPLETED = 'share_completed'
export const EVENT_VIDEO_QUALIFIED_VIEW = 'video_qualified_view'
export const EVENT_VIDEO_ENGAGED_VIEW = 'video_engaged_view'
export const EVENT_VIDEO_INTERESTED_VIEW = 'video_interested_view'
export const EVENT_VIDEO_FIVE_MIN_VIEW = 'video_5_min_view'
export const EVENT_VIDEO_COMPLETED = 'video_completed'
export const EVENT_VIDEO_SPEED_CHANGED = 'video_speed_changed'
export const EVENT_VIDEO_AUDIO_CHANGED = 'video_audio_changed'
export const EVENT_VIDEO_SUBTITLES_SET = 'video_subtitles_set'
export const EVENT_PREVIEW_PLAYED = 'preview_played'
export const EVENT_PLAYER_INFO_TOGGLED = 'player_info_toggled'
export const EVENT_SPOTLIGHT_IMPRESSION = 'spotlight_impression'
export const EVENT_SPOTLIGHT_PLAY_TOGGLE = 'spotlight_play_toggle'
export const EVENT_SPOTLIGHT_AUDIO_TOGGLE = 'spotlight_audio_toggle'
export const EVENT_CREATE_ACCOUNT_PRECURSOR = 'create_account_precursor'
export const EVENT_ACCOUNT_CONFIRM_DETAILS = 'account_confirm_details'
export const EVENT_SIGN_UP = 'sign_up'
export const EVENT_PLAN_SELECT_PRECURSOR = 'plan_select_precursor'
export const EVENT_BEGIN_CHECKOUT = 'begin_checkout'
export const EVENT_PAYMENT_INFO_PAGE = 'payment_info_page'
export const EVENT_PURCHASE = 'purchase'
export const EVENT_PURCHASE_PLAN_UPGRADE = 'purchase_plan_upgrade'
export const EVENT_PURCHASED_MONTHLY_WITH_TRIAL = 'purchased_monthly_with_trial'
export const EVENT_PURCHASED_MONTHLY_DIRECT = 'purchased_monthly_direct'
export const EVENT_PURCHASED_ANNUAL_WITH_TRIAL = 'purchased_annual_with_trial'
export const EVENT_PURCHASED_ANNUAL_DIRECT = 'purchased_annual_direct'
export const EVENT_PURCHASED_EVENTS_PLUS = 'purchased_events_plus'
export const EVENT_PURCHASED_PROMOTIONAL_PLAN = 'purchased_promotional_plan'
export const EVENT_PLAN_ELIGIBILITY_RETURN_BUTTON_CLICKED = 'plan_eligibility_return_button_clicked'
export const EVENT_PLAN_ELIGIBILITY_RESUME_SUBSCRIPTION_CLICKED = 'plan_eligibility_resume_subscription_clicked'
export const EVENT_CHECKOUT_UPDATE_EMAIL = 'checkout_update_email'
export const EVENT_FILTER_APPLIED = 'filter_applied'
export const EVENT_CONTENT_RATING = 'content_rating'
export const EVENT_CHROMECAST_CONNECTED = 'chromecast_connected'
export const EVENT_AIRPLAY_CONNECTED = 'airplay_connected'
export const EVENT_CUSTOM_EVENT = 'custom_event'
export const PAYPAL_POPUP_OPENED_EVENT = 'paypal_popup_opened'
export const EVENT_START_FREE_TRIAL_CLICKED = 'start_free_trial_clicked'
export const TAG_CLICKED_EVENT = 'tag_clicked'
export const ARTICLE_CLICKED_EVENT = 'article_clicked'
export const USER_LOGIN_NEW_TO_GAIA_CLICK_EVENT = 'user_login_new_to_gaia_click'
export const NOTIFICATIONS_RECOMMENDED_PERMISSION_TOGGLED_EVENT = 'notifications_recommended_permission_toggled'
export const NOTIFICATIONS_NEW_CONTENT_PERMISSION_TOGGLED_EVENT = 'notifications_new_content_permission_toggled'
export const TESTAROSSA_SPOTLIGHT_CLICKED_EVENT = 'testarossa_spotlight_clicked'
export const PAGEVIEW_EVENT = 'Pageview'
export const EVENT_SHARE_OFFER_CLICKED = 'share_offer_clicked'
export const EVENT_PLAYLIST_TILE_CTA_CLICKED = 'playlist_tile_cta_clicked'
export const EVENT_CHECKOUT_EDIT_CLICKED = 'checkout_edit_clicked'
export const EVENT_LOG_IN_EMAIL_REQUESTED = 'log_in_email_requested'
export const EVENT_LOGIN = 'login'
export const EVENT_VIEW_MORE_CLICKED = 'view_more_clicked'
export const EVENT_OPTIMIZELY_FEATURE_TEST_ENROLLMENT = 'optimizely_feature_test_enrollment'
export const EVENT_PURCHASE_REACTIVATION = 'purchase_reactivation'
export const EVENT_CANCEL_FLOW_REACTIVATE_CLICKED = 'cancel_flow_reactivate_clicked'
export const EVENT_CANCEL_FLOW_COMING_SOON_CLICKED = 'cancel_flow_coming_soon_clicked'
export const EVENT_CANCEL_FLOW_AI_GUIDE_PROMPT_CLICKED = 'cancel_flow_ai_guide_prompt_clicked'
export const EVENT_RESTART_SUBSCRIPTION_CLICKED = 'restart_subscription_clicked'
export const EVENT_ENTERED_CHECKOUT = 'entered_checkout'
export const EVENT_ONBOARDING_STARTED = 'onboarding_started'
export const EVENT_ONBOARDING_COMPLETED = 'onboarding_completed'
export const EVENT_ONBOARDING_SKIPPED = 'onboarding_skipped'
export const EVENT_ONBOARDING_CHAT_ENDED = 'onboarding_chat_ended'
export const EVENT_PRE_ROLL_IMPRESSION = 'pre_roll_impression'
export const EVENT_PRE_ROLL_SKIPPED = 'pre_roll_skipped'
export const EVENT_PRE_ROLL_COMPLETED = 'pre_roll_completed'
export const EVENT_APP_OPEN_BANNER_CLICKED = 'app_open_banner_clicked'
export const EVENT_APP_OPEN_BANNER_DISMISSED = 'app_open_banner_dismissed'
export const EVENT_SEARCH_PERFORMED = 'search_performed'
export const EVENT_APP_ERROR_EXPERIENCED = 'app_error_experienced'
export const EVENT_FEEDBACK_GIVEN = 'feedback_given'
export const EVENT_SHORT_STARTED = 'short_started'
export const EVENT_SHORT_NEXT = 'short_next'
export const EVENT_SHORT_70_COMPLETE = 'short_70_complete'
export const EVENT_SHORT_SHARED = 'short_shared'

// GA4 AI events
export const EVENT_AI_PAGE_VIEW_MEMBER_HOME = 'ai_page_view_member_home'
export const EVENT_AI_NAVIGATION_CLICKED = 'ai_navigation_clicked'
export const EVENT_AI_RESPONSE_FEEDBACK = 'ai_response_feedback'
export const EVENT_AI_RESPONSE_REFRESH = 'ai_response_refresh'
export const EVENT_AI_RESPONSE_COPIED = 'ai_response_copied'
export const EVENT_AI_MESSAGE_SENT = 'ai_message_sent'
export const EVENT_AI_SPEECH_TO_TEXT = 'ai_speech_to_text'
export const EVENT_AI_RATE_LIMITED = 'ai_rate_limited'
export const EVENT_AI_MESSAGE_RECEIVED = 'ai_message_received'
export const EVENT_AI_ERROR_RESPONSE = 'ai_error_response'
export const EVENT_AI_MESSAGE_FAILURE = 'ai_message_failure'
export const EVENT_AI_UNRECOGNIZED_INPUT = 'ai_unrecognized_input'
export const EVENT_AI_CONVERSATION_STARTED = 'ai_conversation_started'
export const EVENT_AI_CONVERSATION_OPENED = 'ai_conversation_opened'
export const EVENT_AI_CONVERSATION_FAVORITED = 'ai_conversation_favorited'
export const EVENT_AI_CONVERSATION_RESUMED = 'ai_conversation_resumed'
export const EVENT_AI_CONVERSATION_NAME_UPDATED = 'ai_conversation_name_updated'
export const EVENT_AI_CONVERSATION_UNFAVORITED = 'ai_conversation_unfavorited'
export const EVENT_AI_CONVERSATION_DELETED = 'ai_conversation_deleted'
export const EVENT_AI_PAGE_VIEW_CHAT_HOME = 'ai_page_view_chat_home'
export const EVENT_AI_PERSONA_SELECTED = 'ai_persona_selected'
export const EVENT_AI_MODULE_CLICKED = 'ai_module_clicked'
export const EVENT_AI_MODULE_OPENED = 'ai_module_opened'
export const EVENT_AI_MODULE_CLOSED = 'ai_module_closed'
export const EVENT_AI_MODULE_VIEWED = 'ai_module_viewed'
export const EVENT_AI_CANCEL_MODAL_VIEWED = 'ai_cancel_modal_viewed'
export const EVENT_AI_CANCEL_MODAL_CANCEL_CLICKED = 'ai_cancel_modal_cancel_clicked'
export const EVENT_AI_CANCEL_MODAL_ENGAGED = 'ai_cancel_modal_engaged'
export const EVENT_AI_RECOMMENDATION_IMPRESSION = 'ai_recommendation_viewed'
export const EVENT_AI_RECOMMENDATION_CLICKED = 'ai_recommendation_clicked'
export const EVENT_AI_RECOMMENDATION_PLAYED = 'ai_recommendation_played'
export const EVENT_AI_RECOMMENDATION_RECEIVED = 'ai_recommendation_received'

// UI Location constants (Title Case with spaces)
export const UI_LOCATION = {
  AI_CHAT: 'AI Chat',
  AI_VOICE_MODE: 'AI Voice Mode',
  ALL_SERIES: 'All Series',
  DETAIL_PAGE: 'Detail Page',
  END_SCREEN: 'End Screen',
  EVENTS: 'Events',
  EVENTS_AMA: 'Events AMA',
  FILMS_DOCS: 'Films & Docs',
  GUIDES: 'Guides',
  MANAGE_PLAYLIST_MODAL: 'Manage Playlist Modal',
  MEDITATION_PRACTICES: 'Meditation Practices',
  MEMBER_HOME: 'Member Home',
  MY_ACCOUNT: 'My Account',
  PERSON: 'Person',
  PRECURSOR_CHECKOUT: 'Precursor Checkout',
  RECIPES: 'Recipes',
  RECENTLY_ADDED: 'Recently Added',
  SEARCH: 'Search',
  SERIES: 'Series',
  SETTINGS: 'Settings',
  SIMPLIFIED_CHECKOUT: 'Simplified Checkout',
  TOPIC_PAGE: 'Topic Page',
  UNKNOWN_PAGE: 'Unknown Page',
  VIDEO_PLAYER: 'Video Player',
  YOGA_HOME: 'Yoga Home',
  YOGA_PRACTICES: 'Yoga Practices',
}

// UI Element constants (Title Case with spaces)
export const UI_ELEMENT = {
  TEXT_FIELD: 'Text Field',
  PROMPT: 'Prompt',
  VOICE_MODE: 'Voice Mode',
  CONVERSATION_LIST: 'Conversation List',
  NEW_BUTTON: 'New Button',
  HYPERLINK: 'Hyperlink',
  TILE: 'Tile',
  AUTOPLAY: 'Autoplay',
  VIDEO_PLAYER: 'Video Player',
  DETAIL_PAGE_PRIMARY: 'Detail Page Primary',
  FIRST_TOUCH: '1st touch',
  JUMBOTRON_DETAIL_PAGE: 'Jumbotron Detail Page',
  APP_DOWNLOAD_BANNER: 'App Download Banner',
}

// Event log events that are sent to the V2 event log
export const GAIA_EVENT_PLAY_CLICK = 'PlayClick'
export const GAIA_EVENT_DETAIL_PAGE_CLICKED = 'DetailPageClicked'
export const GAIA_EVENT_PLAYLIST_ITEM_REMOVED = 'PlaylistItemRemoved'
export const GAIA_EVENT_PLAYLIST_ITEM_ADDED = 'PlaylistItemAdded'
export const GAIA_EVENT_SEARCH_PERFORMED = 'SearchPerformed'
export const GAIA_EVENT_TOPIC_CLICKED = 'TopicClicked'
export const GAIA_EVENT_SHARE_INITIATED = 'ShareInitiated'
export const GAIA_EVENT_PREVIEW_PLAYED = 'PreviewPlayed'
export const GAIA_EVENT_VIDEO_PLAYER_OPENED = 'VideoPlayerOpened'
export const GAIA_EVENT_CHROMECAST_CONNECTED = 'ChromecastConnected'
export const GAIA_EVENT_AIRPLAY_CONNECTED = 'AirplayConnected'
export const GAIA_EVENT_PLAYLIST_CREATED = 'PlaylistCreated'
export const GAIA_EVENT_PLAYLIST_SHARED = 'PlaylistShared'
export const GAIA_EVENT_PLAYLIST_DELETED = 'PlaylistDeleted'
export const GAIA_EVENT_ONBOARDING_STARTED = 'OnboardingStarted'
export const GAIA_EVENT_ONBOARDING_COMPLETED = 'OnboardingCompleted'
export const GAIA_EVENT_APP_ERROR_EXPERIENCED = 'AppErrorExperienced'

export const CHECKOUT_STEP_EVENTS = List([
  EVENT_CREATE_ACCOUNT_PRECURSOR,
  EVENT_ACCOUNT_CONFIRM_DETAILS,
  EVENT_SIGN_UP,
  EVENT_PLAN_SELECT_PRECURSOR,
  EVENT_BEGIN_CHECKOUT,
  EVENT_PAYMENT_INFO_PAGE,
  EVENT_PURCHASE,
  EVENT_PURCHASE_PLAN_UPGRADE,
  EVENT_PURCHASED_MONTHLY_WITH_TRIAL,
  EVENT_PURCHASED_MONTHLY_DIRECT,
  EVENT_PURCHASED_ANNUAL_WITH_TRIAL,
  EVENT_PURCHASED_ANNUAL_DIRECT,
  EVENT_PURCHASED_EVENTS_PLUS,
  EVENT_PURCHASED_PROMOTIONAL_PLAN,
])

export const EVENT_LOG_EVENTS = List([
  EVENT_PLAY_CLICK,
  EVENT_CLICK_TO_DETAILS_PAGE,
  EVENT_REMOVED_FROM_PLAY_LIST,
  EVENT_ADDED_TO_PLAY_LIST,
  EVENT_SEARCH_PERFORMED,
  EVENT_TOPIC_CLICKED,
  EVENT_SHARE_INITIATED,
  EVENT_PREVIEW_PLAYED,
  EVENT_VIDEO_PLAYER_OPENED,
  EVENT_CHROMECAST_CONNECTED,
  EVENT_AIRPLAY_CONNECTED,
  EVENT_PLAY_LIST_CREATED,
  EVENT_PLAY_LIST_SHARED,
  EVENT_PLAY_LIST_DELETED,
  EVENT_ONBOARDING_STARTED,
  EVENT_ONBOARDING_COMPLETED,
  EVENT_APP_ERROR_EXPERIENCED,
])

export const EVENT_DEFAULT_VALUES = fromJS({
  properties: {},
})
export const NAVIGATION_EVENT_LABELS = {
  LOGO: 'logo',
  IAF: 'invite a friend',
  CAREER: 'work at gaia',
  LANGUAGE_GLOBE: 'language globe',
  NOTIFICATIONS: 'notifications',
  SETTINGS: 'settings',
  USER_MENU: 'user menu',
}

export const EVENT_LOG_INPUT_SCHEMA = {
  eventName: undefined,
  // eventSourceUrl: undefined, - future use
  // actionSource: undefined, - future use
  // eventTime: undefined, - future use
  // testId: undefined, - future use
  // eventId: undefined, - future use
  data: {
    contentTitleGroupId: undefined,
    recommId: undefined,
    // rating: undefined, - future use
    // fbp: undefined, - future use
    // fbc: undefined, - future use
    // currency: undefined, - future use
    // orderId: undefined, - future use
    // price: undefined, - future use
    // externalId: undefined, - future use
    // email: undefined, - future use
    // contentIds: undefined, - future use
    // externalId: undefined, - future use
    // contentName: undefined, - future use
    contentType: undefined,
    membershipStatus: undefined,
    userInTest: undefined,
    userLanguage: undefined,
    guestPhase: undefined,
    appName: undefined,
    appVersion: undefined,
    mediaLanguage: undefined,
    rowPlacement: undefined,
    tileNumber: undefined,
    rowName: undefined,
    isFeaturedMedia: undefined,
    allTestsCollated: undefined,
    pageLocation: undefined,
    uiLocation: undefined,
    uiElement: undefined,
    searchQuery: undefined,
    topicId: undefined,
    topicName: undefined,
    errorType: undefined,
    mediaId: undefined,
    playlistName: undefined,
    externalId: undefined,
  },
}

/**
 * Convert event name to GraphQL enum format (PascalCase)
 * @param {string} eventName - The event name to convert (e.g., "play_click")
 * @returns {string} The event name in enum format (e.g., "PlayClick")
 */
function formatGaiaEventName (eventName) {
  if (!eventName || !_isString(eventName)) {
    return eventName
  }

  switch (eventName) {
    case EVENT_PLAY_CLICK:
      return GAIA_EVENT_PLAY_CLICK
    case EVENT_CLICK_TO_DETAILS_PAGE:
      return GAIA_EVENT_DETAIL_PAGE_CLICKED
    case EVENT_REMOVED_FROM_PLAY_LIST:
      return GAIA_EVENT_PLAYLIST_ITEM_REMOVED
    case EVENT_ADDED_TO_PLAY_LIST:
      return GAIA_EVENT_PLAYLIST_ITEM_ADDED
    case EVENT_SEARCH_PERFORMED:
      return GAIA_EVENT_SEARCH_PERFORMED
    case EVENT_TOPIC_CLICKED:
      return GAIA_EVENT_TOPIC_CLICKED
    case EVENT_SHARE_INITIATED:
      return GAIA_EVENT_SHARE_INITIATED
    case EVENT_PREVIEW_PLAYED:
      return GAIA_EVENT_PREVIEW_PLAYED
    case EVENT_VIDEO_PLAYER_OPENED:
      return GAIA_EVENT_VIDEO_PLAYER_OPENED
    case EVENT_CHROMECAST_CONNECTED:
      return GAIA_EVENT_CHROMECAST_CONNECTED
    case EVENT_AIRPLAY_CONNECTED:
      return GAIA_EVENT_AIRPLAY_CONNECTED
    case EVENT_PLAY_LIST_CREATED:
      return GAIA_EVENT_PLAYLIST_CREATED
    case EVENT_PLAY_LIST_SHARED:
      return GAIA_EVENT_PLAYLIST_SHARED
    case EVENT_PLAY_LIST_DELETED:
      return GAIA_EVENT_PLAYLIST_DELETED
    case EVENT_ONBOARDING_STARTED:
      return GAIA_EVENT_ONBOARDING_STARTED
    case EVENT_ONBOARDING_COMPLETED:
      return GAIA_EVENT_ONBOARDING_COMPLETED
    case EVENT_APP_ERROR_EXPERIENCED:
      return GAIA_EVENT_APP_ERROR_EXPERIENCED
    default:
      return eventName
  }
}

const EVENT_LOG_EVENTS_ALLOW_WITHOUT_CONTENT_ID = [
  EVENT_SEARCH_PERFORMED,
  EVENT_TOPIC_CLICKED,
  EVENT_APP_ERROR_EXPERIENCED,
  EVENT_PLAY_LIST_CREATED,
  EVENT_PLAY_LIST_DELETED,
  EVENT_PLAY_LIST_SHARED,
  EVENT_ONBOARDING_STARTED,
  EVENT_ONBOARDING_COMPLETED,
]

/**
 * Format the event log data
 * @param {Map} data - The event data
 * @returns {Object} The formatted event log data
 */
export function formatEventLogData (data = Map()) {
  if (!Map.isMap(data) || data.isEmpty()) {
    return {}
  }

  const rawEventName = data.get('event') || data.get('eventName')
  const formattedEventName = rawEventName ? formatGaiaEventName(rawEventName) : undefined
  if (!formattedEventName) {
    return {}
  }

  const contentType = getBaseContentType(data.get('content_type'))
  const contentId = data.get('content_id')
  const numericContentId = _toNumber(contentId)
  const hasValidContentId = numericContentId >= 1

  if (!hasValidContentId && !EVENT_LOG_EVENTS_ALLOW_WITHOUT_CONTENT_ID.includes(rawEventName)) {
    return {}
  }

  let contentTitleGroupId
  if (hasValidContentId) {
    contentTitleGroupId = createTitleGroupId(contentId, contentType) || undefined
  }

  const mediaIdRaw = data.get('media_id')
  const eventData = {
    ...(hasValidContentId ? {
      contentTitleGroupId,
      contentType,
    } : {}),
    recommId: data.get('recomm_id') || data.get('recommId'),
    membershipStatus: data.get('membership_status'),
    userInTest: data.get('user_in_test'),
    userLanguage: data.get('user_language'),
    guestPhase: data.get('guest_phase'),
    appName: data.get('app_name'),
    appVersion: data.get('app_version'),
    mediaLanguage: data.get('media_language'),
    ...(data.has('row_placement') && !_isUndefined(data.get('row_placement')) ? { rowPlacement: _toInteger(data.get('row_placement')) } : {}),
    ...(data.has('tile_number') && !_isUndefined(data.get('tile_number')) ? { tileNumber: _toInteger(data.get('tile_number')) } : {}),
    rowName: data.get('row_name'),
    isFeaturedMedia: data.get('is_featured_media'),
    allTestsCollated: data.get('all_tests_collated'),
    pageLocation: data.get('current_url'),
    uiLocation: data.get('ui_location'),
    uiElement: data.get('ui_element'),
    externalId: data.get('gaia_uuid'),
    ...(mediaIdRaw != null && String(mediaIdRaw).trim() !== ''
      ? { mediaId: String(mediaIdRaw) }
      : {}),
  }

  if (rawEventName === EVENT_SEARCH_PERFORMED) {
    const qRaw = data.get('search_query')
    const searchQuery = qRaw == null ? '' : String(qRaw).trim()
    if (searchQuery === '') return {}
    eventData.searchQuery = searchQuery
  } else if (rawEventName === EVENT_TOPIC_CLICKED) {
    const tn = data.get('topic_name')
    const tid = data.get('topic_id')
    const topicName = tn != null ? String(tn).trim() : ''
    const topicId = tid != null ? String(tid).trim() : ''
    if (topicName === '' && topicId === '') return {}
    if (topicId !== '') eventData.topicId = topicId
    if (topicName !== '') eventData.topicName = topicName
  } else if (rawEventName === EVENT_APP_ERROR_EXPERIENCED) {
    const etRaw = data.get('error_type')
    const errorType = etRaw == null ? '' : String(etRaw).trim()
    if (errorType === '') return {}
    eventData.errorType = errorType
  } else if (
    rawEventName === EVENT_PLAY_LIST_CREATED
    || rawEventName === EVENT_PLAY_LIST_DELETED
    || rawEventName === EVENT_PLAY_LIST_SHARED
  ) {
    const pn = data.get('playlist_name')
    const playlistName = pn == null ? '' : String(pn).trim()
    if (playlistName === '') return {}
    eventData.playlistName = playlistName
  }

  const cleanedData = _omitBy(eventData, (value) => {
    return _isUndefined(value)
  })

  const formatted = _assign(_cloneDeep(EVENT_LOG_INPUT_SCHEMA), {
    eventName: formattedEventName,
    data: cleanedData,
  })

  return _omitBy(formatted, (value) => {
    return _isUndefined(value)
  })
}

// GA4 events
export const PLAY_CLICK_GA4_EVENT = fromJS({
  event: EVENT_PLAY_CLICK,
})
export const PLAY_LIST_CREATED_GA4_EVENT = fromJS({
  event: EVENT_PLAY_LIST_CREATED,
})
export const PLAY_LIST_DELETED_GA4_EVENT = fromJS({
  event: EVENT_PLAY_LIST_DELETED,
})
export const PLAY_LIST_SHARED_GA4_EVENT = fromJS({
  event: EVENT_PLAY_LIST_SHARED,
})
export const REMOVED_FROM_PLAY_LIST_GA4_EVENT = fromJS({
  event: EVENT_REMOVED_FROM_PLAY_LIST,
  ui_location: UI_LOCATION.MANAGE_PLAYLIST_MODAL,
})
export const ADDED_TO_PLAY_LIST_GA4_EVENT = fromJS({
  event: EVENT_ADDED_TO_PLAY_LIST,
  ui_location: UI_LOCATION.MANAGE_PLAYLIST_MODAL,
})
export const SEARCH_PERFORMED_GA4_EVENT = fromJS({
  event: EVENT_SEARCH_PERFORMED,
})
export const APP_ERROR_EXPERIENCED_GA4_EVENT = fromJS({
  event: EVENT_APP_ERROR_EXPERIENCED,
})
export const ACCOUNT_PAUSED_GA4_EVENT = fromJS({
  event: EVENT_ACCOUNT_PAUSED,
})
export const ACCOUNT_UNPAUSED_GA4_EVENT = fromJS({
  event: EVENT_ACCOUNT_UNPAUSED,
})
export const ROW_IMPRESSION_GA4_EVENT = fromJS({
  event: EVENT_ROW_IMPRESSION,
})
export const TOPIC_CLICKED_GA4_EVENT = fromJS({
  event: EVENT_TOPIC_CLICKED,
})
export const PRIMARY_LANGUAGE_CHANGED_GA4_EVENT = fromJS({
  event: EVENT_PRIMARY_LANGUAGE_CHANGED,
})
export const SECONDARY_LANGUAGE_CHANGED_GA4_EVENT = fromJS({
  event: EVENT_SECONDARY_LANGUAGE_CHANGED,
})
export const EMAIL_CAPTURED_GA4_EVENT = fromJS({
  event: EVENT_EMAIL_CAPTURED,
})
export const AUTOPLAY_TOGGLED_GA4_EVENT = fromJS({
  event: EVENT_AUTOPLAY_TOGGLED,
})
export const COMMENT_GA4_EVENT = fromJS({
  event: EVENT_COMMENT,
})
export const ITEM_REMOVED_FROM_HISTORY_GA4_EVENT = fromJS({
  event: EVENT_ITEM_REMOVED_FROM_HISTORY,
})
export const SERIES_FOLLOWED_GA4_EVENT = fromJS({
  event: EVENT_SERIES_FOLLOWED,
})
export const SERIES_UNFOLLOWED_GA4_EVENT = fromJS({
  event: EVENT_SERIES_UNFOLLOWED,
})
export const NOTIFICATIONS_OPENED_GA4_EVENT = fromJS({
  event: EVENT_NOTIFICATIONS_OPENED,
})
export const NOTIFICATIONS_MANAGE_CLICKED_GA4_EVENT = fromJS({
  event: EVENT_NOTIFICATIONS_MANAGE_CLICKED,
})
export const NOTIFICATIONS_VIEW_ALL_CLICKED_GA4_EVENT = fromJS({
  event: EVENT_NOTIFICATIONS_VIEW_ALL_CLICKED,
})
export const CANCEL_FLOW_REASON_SELECTED_GA4_EVENT = fromJS({
  event: EVENT_CANCEL_FLOW_REASON_SELECTED,
})
export const CANCEL_FLOW_FREE_MONTH_SELECTED_GA4_EVENT = fromJS({
  event: EVENT_CANCEL_FLOW_FREE_MONTH_SELECTED,
})
export const CANCEL_FLOW_FREE_MONTH_OFFER_SHOWN_GA4_EVENT = fromJS({
  event: EVENT_CANCEL_FLOW_FREE_MONTH_OFFER_SHOWN,
})
export const CANCEL_FLOW_CHANGE_PLAN_SELECTED_GA4_EVENT = fromJS({
  event: EVENT_CANCEL_FLOW_CHANGE_PLAN_SELECTED,
})
export const CANCEL_FLOW_CANCEL_CLICKED_GA4_EVENT = fromJS({
  event: EVENT_CANCEL_FLOW_CANCEL_CLICKED,
})
export const CANCEL_FLOW_THREE_MONTH_OFFER_SHOWN_GA4_EVENT = fromJS({
  event: EVENT_CANCEL_FLOW_THREE_MONTH_OFFER_SHOWN,
})
export const CANCEL_FLOW_THREE_MONTH_OFFER_SELECTED_GA4_EVENT = fromJS({
  event: EVENT_CANCEL_FLOW_THREE_MONTH_OFFER_SELECTED,
})
export const CANCEL_FLOW_THREE_MONTH_OFFER_REJECTED_GA4_EVENT = fromJS({
  event: EVENT_CANCEL_FLOW_THREE_MONTH_OFFER_REJECTED,
})
export const CHANGE_PLAN_OFFER_VIEW_GA4_EVENT = fromJS({
  event: EVENT_CHANGE_PLAN_OFFER_VIEW,
})
export const CHANGE_PLAN_OFFER_ACCEPT_GA4_EVENT = fromJS({
  event: EVENT_CHANGE_PLAN_OFFER_ACCEPT,
})
export const CHANGE_PLAN_OFFER_CONFIRM_GA4_EVENT = fromJS({
  event: EVENT_CHANGE_PLAN_OFFER_CONFIRM,
})
export const CANCEL_FLOW_PRICE_INCREASE_OFFER_SHOWN_GA4_EVENT = fromJS({
  event: EVENT_CANCEL_FLOW_PRICE_INCREASE_OFFER_SHOWN,
})
export const CANCEL_FLOW_PRICE_INCREASE_OFFER_SELECTED_GA4_EVENT = fromJS({
  event: EVENT_CANCEL_FLOW_PRICE_INCREASE_OFFER_SELECTED,
})
export const CANCEL_FLOW_PRICE_INCREASE_OFFER_CONFIRMED_GA4_EVENT = fromJS({
  event: EVENT_CANCEL_FLOW_PRICE_INCREASE_OFFER_CONFIRMED,
})
export const CANCEL_FLOW_PRICE_INCREASE_OFFER_REJECTED_GA4_EVENT = fromJS({
  event: EVENT_CANCEL_FLOW_PRICE_INCREASE_OFFER_REJECTED,
})
export const PAUSED_OFFER_SHOWN_GA4_EVENT = fromJS({
  event: EVENT_PAUSED_OFFER_SHOWN,
})
export const SPOTLIGHT_TOGGLED_GA4_EVENT = fromJS({
  event: EVENT_SPOTLIGHT_TOGGLED,
})
export const AI_MODULE_VISIBILITY_TOGGLED_GA4_EVENT = fromJS({
  event: EVENT_AI_MODULE_VISIBILITY_TOGGLED,
})
export const AI_VIDEO_GUIDE_TOGGLED_GA4_EVENT = fromJS({
  event: EVENT_AI_VIDEO_GUIDE_TOGGLED,
})
export const AI_VIDEOGUIDE_ENABLED_GA4_EVENT = fromJS({
  event: 'ai_videoguide_enabled',
})
export const AI_VIDEOGUIDE_DISABLED_GA4_EVENT = fromJS({
  event: 'ai_videoguide_disabled',
})
export const NAV_V1_CLICKED_GA4_EVENT = fromJS({
  event: EVENT_NAV_CLICKED,
  nav_version: 'v1',
})
export const NAV_V2_CLICKED_GA4_EVENT = fromJS({
  event: EVENT_NAV_CLICKED,
  nav_version: 'v2',
})
export const NAV_V4_CLICKED_GA4_EVENT = fromJS({
  event: EVENT_NAV_CLICKED,
  nav_version: 'v4',
})
export const PROMO_UNIT_IMPRESSION_GA4_EVENT = fromJS({
  event: EVENT_PROMO_UNIT_IMPRESSION,
})
export const PROMO_UNIT_CLICK_GA4_EVENT = fromJS({
  event: EVENT_PROMO_UNIT_CLICK,
})
export const APP_OPEN_BANNER_CLICKED_GA4_EVENT = fromJS({
  event: EVENT_APP_OPEN_BANNER_CLICKED,
  ui_element: UI_ELEMENT.APP_DOWNLOAD_BANNER,
})
export const APP_OPEN_BANNER_DISMISSED_GA4_EVENT = fromJS({
  event: EVENT_APP_OPEN_BANNER_DISMISSED,
  ui_element: UI_ELEMENT.APP_DOWNLOAD_BANNER,
})
export const CLICK_TO_DETAILS_PAGE_GA4_EVENT = fromJS({
  event: EVENT_CLICK_TO_DETAILS_PAGE,
})
export const VIDEO_PLAYER_OPENED_GA4_EVENT = fromJS({
  event: EVENT_VIDEO_PLAYER_OPENED,
})
export const VIDEO_LOADS_AND_STARTS_PLAY_GA4_EVENT = fromJS({
  event: EVENT_VIDEO_LOADS_AND_STARTS_PLAY,
})
export const SHARE_INITIATED_GA4_EVENT = fromJS({
  event: EVENT_SHARE_INITIATED,
  full_share: true, // note: this will change in the future but right now is set to true
})
export const SHARE_COMPLETED_GA4_EVENT = fromJS({
  event: EVENT_SHARE_COMPLETED,
})
export const VIDEO_QUALIFIED_VIEW_GA4_EVENT = fromJS({
  event: EVENT_VIDEO_QUALIFIED_VIEW,
})
export const VIDEO_ENGAGED_VIEW_GA4_EVENT = fromJS({
  event: EVENT_VIDEO_ENGAGED_VIEW,
})
export const VIDEO_INTERESTED_VIEW_GA4_EVENT = fromJS({
  event: EVENT_VIDEO_INTERESTED_VIEW,
})
export const VIDEO_FIVE_MIN_VIEW_GA4_EVENT = fromJS({
  event: EVENT_VIDEO_FIVE_MIN_VIEW,
})
export const VIDEO_COMPLETED_GA4_EVENT = fromJS({
  event: EVENT_VIDEO_COMPLETED,
})
export const VIDEO_SPEED_CHANGED_GA4_EVENT = fromJS({
  event: EVENT_VIDEO_SPEED_CHANGED,
})
export const VIDEO_AUDIO_CHANGED_GA4_EVENT = fromJS({
  event: EVENT_VIDEO_AUDIO_CHANGED,
})
export const VIDEO_SUBTITLES_SET_GA4_EVENT = fromJS({
  event: EVENT_VIDEO_SUBTITLES_SET,
})
export const PREVIEW_PLAYED_GA4_EVENT = fromJS({
  event: EVENT_PREVIEW_PLAYED,
})
export const PLAYER_INFO_TOGGLED_GA4_EVENT = fromJS({
  event: EVENT_PLAYER_INFO_TOGGLED,
})
export const SPOTLIGHT_IMPRESSION_GA4_EVENT = fromJS({
  event: EVENT_SPOTLIGHT_IMPRESSION,
})
export const SPOTLIGHT_PLAY_TOGGLE_GA4_EVENT = fromJS({
  event: EVENT_SPOTLIGHT_PLAY_TOGGLE,
})
export const SPOTLIGHT_AUDIO_TOGGLE_GA4_EVENT = fromJS({
  event: EVENT_SPOTLIGHT_AUDIO_TOGGLE,
})
export const CREATE_ACCOUNT_PRECURSOR_GA4_EVENT = fromJS({
  event: EVENT_CREATE_ACCOUNT_PRECURSOR,
})
export const ACCOUNT_CONFIRM_DETAILS_GA4_EVENT = fromJS({
  event: EVENT_ACCOUNT_CONFIRM_DETAILS,
})
export const SIGN_UP_GA4_EVENT = fromJS({
  event: EVENT_SIGN_UP,
})
export const PLAN_SELECT_PRECURSOR_GA4_EVENT = fromJS({
  event: EVENT_PLAN_SELECT_PRECURSOR,
})
export const BEGIN_CHECKOUT_GA4_EVENT = fromJS({
  event: EVENT_BEGIN_CHECKOUT,
})
export const PAYMENT_INFO_PAGE_GA4_EVENT = fromJS({
  event: EVENT_PAYMENT_INFO_PAGE,
})
export const PURCHASE_GA4_EVENT = fromJS({
  event: EVENT_PURCHASE,
})
export const PURCHASED_MONTHLY_WITH_TRIAL_GA4_EVENT = fromJS({
  event: EVENT_PURCHASED_MONTHLY_WITH_TRIAL,
})
export const PURCHASED_MONTHLY_DIRECT_GA4_EVENT = fromJS({
  event: EVENT_PURCHASED_MONTHLY_DIRECT,
})
export const PURCHASED_ANNUAL_WITH_TRIAL_GA4_EVENT = fromJS({
  event: EVENT_PURCHASED_ANNUAL_WITH_TRIAL,
})
export const PURCHASED_ANNUAL_DIRECT_GA4_EVENT = fromJS({
  event: EVENT_PURCHASED_ANNUAL_DIRECT,
})
export const PURCHASED_EVENTS_PLUS_GA4_EVENT = fromJS({
  event: EVENT_PURCHASED_EVENTS_PLUS,
})
export const PURCHASED_PROMOTIONAL_PLAN_GA4_EVENT = fromJS({
  event: EVENT_PURCHASED_PROMOTIONAL_PLAN,
})
export const PLAN_ELIGIBILITY_RETURN_BUTTON_CLICKED_GA4_EVENT = fromJS({
  event: EVENT_PLAN_ELIGIBILITY_RETURN_BUTTON_CLICKED,
})
export const PLAN_ELIGIBILITY_RESUME_SUBSCRIPTION_CLICKED_GA4_EVENT = fromJS({
  event: EVENT_PLAN_ELIGIBILITY_RESUME_SUBSCRIPTION_CLICKED,
})
export const FILTER_APPLIED_GA4_EVENT = fromJS({
  event: EVENT_FILTER_APPLIED,
})
export const CONTENT_RATING_GA4_EVENT = fromJS({
  event: EVENT_CONTENT_RATING,
})
export const CHROMECAST_CONNECTED_GA4_EVENT = fromJS({
  event: EVENT_CHROMECAST_CONNECTED,
})
export const AIRPLAY_CONNECTED_GA4_EVENT = fromJS({
  event: EVENT_AIRPLAY_CONNECTED,
})
export const CHECKOUT_UPDATE_EMAIL_GA4_EVENT = fromJS({
  event: EVENT_CHECKOUT_UPDATE_EMAIL,
})
export const CUSTOM_EVENT_GA4_EVENT = fromJS({
  event: EVENT_CUSTOM_EVENT,
})
export const PAYPAL_POPUP_OPENED_GA4_EVENT = fromJS({
  event: PAYPAL_POPUP_OPENED_EVENT,
})
export const START_FREE_TRIAL_CLICKED_GA4_EVENT = fromJS({
  event: EVENT_START_FREE_TRIAL_CLICKED,
})
export const TAG_CLICKED_GA4_EVENT = fromJS({
  event: TAG_CLICKED_EVENT,
})
export const ARTICLE_CLICKED_GA4_EVENT = fromJS({
  event: ARTICLE_CLICKED_EVENT,
})
export const USER_LOGIN_NEW_TO_GAIA_CLICK_GA4_EVENT = fromJS({
  event: USER_LOGIN_NEW_TO_GAIA_CLICK_EVENT,
})
export const NOTIFICATIONS_RECOMMENDED_PERMISSION_TOGGLED_GA4_EVENT = fromJS({
  event: NOTIFICATIONS_RECOMMENDED_PERMISSION_TOGGLED_EVENT,
})
export const NOTIFICATIONS_NEW_CONTENT_PERMISSION_TOGGLED_GA4_EVENT = fromJS({
  event: NOTIFICATIONS_NEW_CONTENT_PERMISSION_TOGGLED_EVENT,
})
export const TESTAROSSA_SPOTLIGHT_CLICKED_GA4_EVENT = fromJS({
  event: TESTAROSSA_SPOTLIGHT_CLICKED_EVENT,
})
export const PAGEVIEW_GA4_EVENT = fromJS({
  event: PAGEVIEW_EVENT,
})
export const CANCEL_FLOW_FREE_MONTH_REJECTED_GA4_EVENT = fromJS({
  event: EVENT_CANCEL_FLOW_FREE_MONTH_REJECTED,
})
export const EMAIL_PERMISSION_TOGGLED_GA4_EVENT = fromJS({
  event: EVENT_EMAIL_PERMISSION_TOGGLED,
})
export const PURCHASE_PLAN_UPGRADE_GA4_EVENT = fromJS({
  event: EVENT_PURCHASE_PLAN_UPGRADE,
})
export const SHARE_OFFER_CLICKED_GA4_EVENT = fromJS({
  event: EVENT_SHARE_OFFER_CLICKED,
})
export const PLAYLIST_TILE_CTA_CLICKED_GA4_EVENT = fromJS({
  event: EVENT_PLAYLIST_TILE_CTA_CLICKED,
})
export const CHECKOUT_EDIT_CLICKED_GA4_EVENT = fromJS({
  event: EVENT_CHECKOUT_EDIT_CLICKED,
  ui_location: UI_LOCATION.SIMPLIFIED_CHECKOUT,
})
export const LOG_IN_EMAIL_REQUESTED_GA4_EVENT = fromJS({
  event: EVENT_LOG_IN_EMAIL_REQUESTED,
})
export const LOGIN_GA4_EVENT = fromJS({
  event: EVENT_LOGIN,
})
export const VIEW_MORE_CLICKED_GA4_EVENT = fromJS({
  event: EVENT_VIEW_MORE_CLICKED,
})
export const OPTIMIZELY_FEATURE_TEST_ENROLLMENT_GA4_EVENT = fromJS({
  event: EVENT_OPTIMIZELY_FEATURE_TEST_ENROLLMENT,
})
export const PURCHASE_REACTIVATION_GA4_EVENT = fromJS({
  event: EVENT_PURCHASE_REACTIVATION,
})
export const CANCEL_FLOW_REACTIVATE_CLICKED_GA4_EVENT = fromJS({
  event: EVENT_CANCEL_FLOW_REACTIVATE_CLICKED,
})
export const CANCEL_FLOW_COMING_SOON_CLICKED_GA4_EVENT = fromJS({
  event: EVENT_CANCEL_FLOW_COMING_SOON_CLICKED,
})
export const CANCEL_FLOW_AI_GUIDE_PROMPT_CLICKED_GA4_EVENT = fromJS({
  event: EVENT_CANCEL_FLOW_AI_GUIDE_PROMPT_CLICKED,
})
export const RESTART_SUBSCRIPTION_CLICKED_GA4_EVENT = fromJS({
  event: EVENT_RESTART_SUBSCRIPTION_CLICKED,
})
export const ENTERED_CHECKOUT_GA4_EVENT = fromJS({
  event: EVENT_ENTERED_CHECKOUT,
})
export const ONBOARDING_STARTED_GA4_EVENT = fromJS({
  event: EVENT_ONBOARDING_STARTED,
})
export const ONBOARDING_COMPLETED_GA4_EVENT = fromJS({
  event: EVENT_ONBOARDING_COMPLETED,
})
export const ONBOARDING_SKIPPED_GA4_EVENT = fromJS({
  event: EVENT_ONBOARDING_SKIPPED,
})
export const ONBOARDING_CHAT_ENDED_GA4_EVENT = fromJS({
  event: EVENT_ONBOARDING_CHAT_ENDED,
})
export const PRE_ROLL_IMPRESSION_GA4_EVENT = fromJS({
  event: EVENT_PRE_ROLL_IMPRESSION,
})
export const PRE_ROLL_SKIPPED_GA4_EVENT = fromJS({
  event: EVENT_PRE_ROLL_SKIPPED,
})
export const PRE_ROLL_COMPLETED_GA4_EVENT = fromJS({
  event: EVENT_PRE_ROLL_COMPLETED,
})
export const FEEDBACK_GIVEN_GA4_EVENT = fromJS({
  event: EVENT_FEEDBACK_GIVEN,
})
export const SHORT_STARTED_GA4_EVENT = fromJS({
  event: EVENT_SHORT_STARTED,
})
export const SHORT_NEXT_GA4_EVENT = fromJS({
  event: EVENT_SHORT_NEXT,
})
export const SHORT_70_COMPLETE_GA4_EVENT = fromJS({
  event: EVENT_SHORT_70_COMPLETE,
})
export const SHORT_SHARED_GA4_EVENT = fromJS({
  event: EVENT_SHORT_SHARED,
})

// GA4 AI events
export const AI_PAGE_VIEW_MEMBER_HOME_GA4_EVENT = fromJS({
  event: EVENT_AI_PAGE_VIEW_MEMBER_HOME,
  ui_location: UI_LOCATION.MEMBER_HOME,
})
export const AI_NAVIGATION_CLICKED_GA4_EVENT = fromJS({
  event: EVENT_AI_NAVIGATION_CLICKED,
})
export const AI_RESPONSE_FEEDBACK_GA4_EVENT = fromJS({
  event: EVENT_AI_RESPONSE_FEEDBACK,
})
export const AI_RESPONSE_REFRESH_GA4_EVENT = fromJS({
  event: EVENT_AI_RESPONSE_REFRESH,
})
export const AI_RESPONSE_COPIED_GA4_EVENT = fromJS({
  event: EVENT_AI_RESPONSE_COPIED,
})
export const AI_MESSAGE_SENT_GA4_EVENT = fromJS({
  event: EVENT_AI_MESSAGE_SENT,
})
export const AI_SPEECH_TO_TEXT_GA4_EVENT = fromJS({
  event: EVENT_AI_SPEECH_TO_TEXT,
})
export const AI_RATE_LIMITED_GA4_EVENT = fromJS({
  event: EVENT_AI_RATE_LIMITED,
  ui_location: UI_LOCATION.AI_CHAT,
})
export const AI_MESSAGE_RECEIVED_GA4_EVENT = fromJS({
  event: EVENT_AI_MESSAGE_RECEIVED,
  ui_location: UI_LOCATION.AI_CHAT,
})
export const AI_ERROR_RESPONSE_GA4_EVENT = fromJS({
  event: EVENT_AI_ERROR_RESPONSE,
})
export const AI_MESSAGE_FAILURE_GA4_EVENT = fromJS({
  event: EVENT_AI_MESSAGE_FAILURE,
})
export const AI_UNRECOGNIZED_INPUT_GA4_EVENT = fromJS({
  event: EVENT_AI_UNRECOGNIZED_INPUT,
})
export const AI_CONVERSATION_STARTED_GA4_EVENT = fromJS({
  event: EVENT_AI_CONVERSATION_STARTED,
})
export const AI_CONVERSATION_OPENED_GA4_EVENT = fromJS({
  event: EVENT_AI_CONVERSATION_OPENED,
})
export const AI_CONVERSATION_FAVORITED_GA4_EVENT = fromJS({
  event: EVENT_AI_CONVERSATION_FAVORITED,
})
export const AI_CONVERSATION_RESUMED_GA4_EVENT = fromJS({
  event: EVENT_AI_CONVERSATION_RESUMED,
})
export const AI_CONVERSATION_NAME_UPDATED_GA4_EVENT = fromJS({
  event: EVENT_AI_CONVERSATION_NAME_UPDATED,
})
export const AI_CONVERSATION_UNFAVORITED_GA4_EVENT = fromJS({
  event: EVENT_AI_CONVERSATION_UNFAVORITED,
})
export const AI_CONVERSATION_DELETED_GA4_EVENT = fromJS({
  event: EVENT_AI_CONVERSATION_DELETED,
})
export const AI_PAGE_VIEW_CHAT_HOME_GA4_EVENT = fromJS({
  event: EVENT_AI_PAGE_VIEW_CHAT_HOME,
})
export const AI_PERSONA_SELECTED_GA4_EVENT = fromJS({
  event: EVENT_AI_PERSONA_SELECTED,
})
export const AI_MODULE_CLICKED_GA4_EVENT = fromJS({
  event: EVENT_AI_MODULE_CLICKED,
})
export const AI_MODULE_OPENED_GA4_EVENT = fromJS({
  event: EVENT_AI_MODULE_OPENED,
})
export const AI_MODULE_CLOSED_GA4_EVENT = fromJS({
  event: EVENT_AI_MODULE_CLOSED,
})
export const AI_MODULE_VIEWED_GA4_EVENT = fromJS({
  event: EVENT_AI_MODULE_VIEWED,
})
export const AI_CANCEL_MODAL_VIEWED_GA4_EVENT = fromJS({
  event: EVENT_AI_CANCEL_MODAL_VIEWED,
})
export const AI_CANCEL_MODAL_CANCEL_CLICKED_GA4_EVENT = fromJS({
  event: EVENT_AI_CANCEL_MODAL_CANCEL_CLICKED,
})
export const AI_CANCEL_MODAL_ENGAGED_GA4_EVENT = fromJS({
  event: EVENT_AI_CANCEL_MODAL_ENGAGED,
})
export const AI_RECOMMENDATION_IMPRESSION_GA4_EVENT = fromJS({
  event: EVENT_AI_RECOMMENDATION_IMPRESSION,
  ui_element: UI_ELEMENT.HYPERLINK,
})
export const AI_RECOMMENDATION_CLICKED_GA4_EVENT = fromJS({
  event: EVENT_AI_RECOMMENDATION_CLICKED,
  ui_element: UI_ELEMENT.HYPERLINK,
})
export const AI_RECOMMENDATION_PLAYED_GA4_EVENT = fromJS({
  event: EVENT_AI_RECOMMENDATION_PLAYED,
  ui_element: UI_ELEMENT.HYPERLINK,
  ui_location: UI_LOCATION.VIDEO_PLAYER,
})
export const AI_RECOMMENDATION_RECEIVED_GA4_EVENT = fromJS({
  event: EVENT_AI_RECOMMENDATION_RECEIVED,
  ui_location: UI_LOCATION.AI_CHAT,
})

export function getNavClickedGa4Event (navVersion) {
  let navClickedEvent = fromJS({})
  switch (navVersion) {
    case 'v4':
      navClickedEvent = NAV_V4_CLICKED_GA4_EVENT
      break
    case 'v1':
      navClickedEvent = NAV_V1_CLICKED_GA4_EVENT
      break
    case 'v2':
    default:
      navClickedEvent = NAV_V2_CLICKED_GA4_EVENT
      break
  }

  return navClickedEvent
}

function getPurchaseEventData (planSku) {
  let eventData
  switch (planSku) {
    case PLAN_SKU_ONE_WEEK_FREE_TRIAL_TO_MONTHLY:
    case PLAN_SKU_INCREASED_PRICE_ONE_WEEK_FREE_TRIAL_TO_MONTHLY:
    case PLAN_SKU_PRICE_INCREASE_2026_MONTHLY_TRIAL:
      eventData = {
        name: PURCHASED_MONTHLY_WITH_TRIAL,
        event: EVENT_PURCHASED_MONTHLY_WITH_TRIAL,
        value: 60,
      }
      break
    case PLAN_SKU_MONTHLY:
    case PLAN_SKU_INCREASED_PRICE_MONTHLY:
    case PLAN_SKU_PRICE_INCREASE_2026_MONTHLY:
    case PLAN_SKU_PRICE_INCREASE_2026_MONTHLY_CL:
      eventData = {
        name: PURCHASED_MONTHLY_DIRECT,
        event: EVENT_PURCHASED_MONTHLY_DIRECT,
        value: 120,
      }
      break
    case PLAN_SKU_ONE_WEEK_FREE_TRIAL_TO_ANNUAL:
    case PLAN_SKU_INCREASED_PRICE_ONE_WEEK_FREE_TRIAL_TO_ANNUAL:
    case PLAN_SKU_PRICE_INCREASE_2026_ANNUAL_TRIAL:
      eventData = {
        name: PURCHASED_ANNUAL_WITH_TRIAL,
        event: EVENT_PURCHASED_ANNUAL_WITH_TRIAL,
        value: 130,
      }
      break
    case PLAN_SKU_ANNUAL:
    case PLAN_SKU_INCREASED_PRICE_ANNUAL:
    case PLAN_SKU_PRICE_INCREASE_2026_ANNUAL:
      eventData = {
        name: PURCHASED_ANNUAL_DIRECT,
        event: EVENT_PURCHASED_ANNUAL_DIRECT,
        value: 220,
      }
      break
    case PLAN_SKU_LIVE:
    case PLAN_SKU_INCREASED_PRICE_GAIA_PLUS:
      eventData = {
        name: PURCHASED_EVENTS_PLUS,
        event: EVENT_PURCHASED_EVENTS_PLUS,
        value: 400,
      }
      break
    default:
      eventData = {
        name: PURCHASED_PROMOTIONAL_PLAN,
        event: EVENT_PURCHASED_PROMOTIONAL_PLAN,
        value: 60,
      }
      break
  }

  return eventData
}

export function sentAtDate (date = new Date()) {
  return date.toISOString()
}

export function buildEventPageViewed (data) {
  const { upstreamContext, gaiaScreen } = data
  const newEvent = Map({
    event: 'Page Viewed',
  })

  return createDefaultEvent(data)
    .mergeDeep(createCustomContextProperties(upstreamContext))
    .mergeDeep(createGaiaScreenProperties(gaiaScreen))
    .mergeDeep(newEvent)
}

export function createDefaultEvent (data) {
  const {
    auth,
    page = Map(),
    location,
    windowLocation = global.location,
    date,
    app = Map(),
    language = List(),
  } = data

  const userId = auth ? auth.get('uid', 0) : -1

  const newEvent = fromJS({
    timestamp: sentAtDate(date),
    userId,
    context: {
      app: {
        name: app.get('name'),
        version: app.get('version'),
      },
      page: {
        hash: _get(location, 'hash'),
        path: _get(location, 'pathname'),
        search: _get(location, 'search'),
        title: page.get('title'),
        url: _get(windowLocation, 'href', null),
      },
      traits: {
        preferredLanguages: language.toJS(),
      },
    },
  })
  return EVENT_DEFAULT_VALUES.mergeDeep(newEvent)
}

/**
 * Creates an event properties node for tracking events
 * @param  {Immutable.Map} data map of single-level event properties
 * @return {Immutable.Map} event-final structured properties
 */
export function createCustomContextProperties (data = Map()) {
  if (Map.isMap(data) && data.size > 0) {
    let contentType = data.get('contentType')
    let contentId = data.get('contentId')
    if (data.has('videoId')) {
      contentType = TYPE_CONTENT_VIDEO
      contentId = data.get('videoId')
    } else if (data.has('seriesId')) {
      contentType = TYPE_CONTENT_SERIES
      contentId = data.get('seriesId')
    }
    let properties = fromJS({
      contentId,
      contentType,
      properties: {
        gaiaContext: data,
      },
    })
    if (data.has('videoSpeed')) {
      properties = properties.setIn(
        ['properties', 'videoSpeed'],
        data.get('videoSpeed'),
      )
    }
    if (data.has('isPictureInPictureToggled')) {
      properties = properties.setIn(
        ['properties', 'isPictureInPictureToggled'],
        data.get('isPictureInPictureToggled'),
      )
    }
    return properties
  }
  return Map()
}

/**
 * Creates an event properties node for tracking events
 * @param  {Immutable.Map} data map of single-level event properties
 * @return {Immutable.Map} event-final structured properties
 */
export function createGaiaScreenProperties (data = Map()) {
  if (Map.isMap(data) && data.size > 0) {
    const properties = fromJS({
      properties: {
        gaiaScreen: data,
      },
    })
    return properties
  }

  return Map()
}

export { buildServerEventLogInput } from './build-server-event-log-input'

/**
 * Returns the event object for the purchased 'planSku' event
 * @param  {String} planSku string with the sku of the purchased plan
 * @return {Immutable.Map} event data
 */
export function getPurchasedPlanEventData (planSku) {
  let purchasedPlanEventData = null
  switch (planSku) {
    case PLAN_SKU_ONE_WEEK_FREE_TRIAL_TO_MONTHLY:
    case PLAN_SKU_INCREASED_PRICE_ONE_WEEK_FREE_TRIAL_TO_MONTHLY:
    case PLAN_SKU_PRICE_INCREASE_2026_MONTHLY_TRIAL:
      purchasedPlanEventData = PURCHASED_MONTHLY_WITH_TRIAL_GA4_EVENT
      break
    case PLAN_SKU_MONTHLY:
    case PLAN_SKU_INCREASED_PRICE_MONTHLY:
    case PLAN_SKU_PRICE_INCREASE_2026_MONTHLY:
    case PLAN_SKU_PRICE_INCREASE_2026_MONTHLY_CL:
      purchasedPlanEventData = PURCHASED_MONTHLY_DIRECT_GA4_EVENT
      break
    case PLAN_SKU_ONE_WEEK_FREE_TRIAL_TO_ANNUAL:
    case PLAN_SKU_INCREASED_PRICE_ONE_WEEK_FREE_TRIAL_TO_ANNUAL:
    case PLAN_SKU_PRICE_INCREASE_2026_ANNUAL_TRIAL:
      purchasedPlanEventData = PURCHASED_ANNUAL_WITH_TRIAL_GA4_EVENT
      break
    case PLAN_SKU_ANNUAL:
    case PLAN_SKU_INCREASED_PRICE_ANNUAL:
    case PLAN_SKU_PRICE_INCREASE_2026_ANNUAL:
      purchasedPlanEventData = PURCHASED_ANNUAL_DIRECT_GA4_EVENT
      break
    case PLAN_SKU_LIVE:
    case PLAN_SKU_INCREASED_PRICE_GAIA_PLUS:
      purchasedPlanEventData = PURCHASED_EVENTS_PLUS_GA4_EVENT
      break
    default:
      purchasedPlanEventData = PURCHASED_PROMOTIONAL_PLAN_GA4_EVENT
      break
  }

  return purchasedPlanEventData
}

/**
 * Builds the ecommerce data for the checkout events
 * @param  {Immutable.Map} selectedPlan map with the selected plan data
 * @param  {String} transactionId string with the id of the transaction
 * @return {Object} ecommerce object
 */
export function buildCheckoutEcommerceObject (selectedPlan, transactionId) {
  if (!Map.isMap(selectedPlan) && selectedPlan.size === 0) return {}

  const sku = selectedPlan.get('sku')
  const currency = selectedPlan.get('currencyIso')
  const itemName = selectedPlan.get('name')
  const firstPayment = _toNumber(parseFloat(selectedPlan.get('firstPayment', 0)))
  const fullPrice = List.isList(selectedPlan.get('costs'))
    ? _toNumber(parseFloat(selectedPlan.get('costs').last()).toFixed(2))
    : 0
  const price = firstPayment === 0 ? fullPrice : firstPayment

  const purchaseEventData = getPurchaseEventData(sku)
  const itemsArray = [
    {
      item_id: sku,
      item_name: itemName,
      price,
    },
  ]

  return {
    ecommerce: {
      currency,
      ...(transactionId && { transaction_id: transactionId }),
      value: purchaseEventData.value,
      price,
      items: itemsArray,
    },
  }
}
